import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { AppError } from "config/errors";
import { RootState, useAppDispatch } from "store";
import { getCurrentUserPolicy } from "store/actions/policy";

export const usePolicyData = (refresh = false) => {
  const dispatch = useAppDispatch();
  const [pending, setPending] = useState(refresh ? true : false);
  const [error, setError] = useState("");
  const policy = useSelector((state: RootState) => state.policy);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(getCurrentUserPolicy());
        setPending(false);
        const error = AppError.fromThunk(response);
        if (error) {
          throw error;
        }
      } catch (error) {
        setError(AppError.from(error).fullMessage);
      }
    };

    if (refresh) {
      fetchData();
    }
  }, [dispatch, refresh]);

  return { policy, policyDataPending: pending, policyDataError: error };
};
